import LootItem from "./LootItem";
import { use as useScreen } from "common/src/atoms/ScreenAtom.bs";

const formatOdds = (odds: number): string => {
  const odds2 = odds * 100;
  if (odds2 < 10 && Math.round(odds2) != odds2) {
    return odds2.toFixed(1);
  } else {
    return odds2.toFixed(0);
  }
};

type Data = Array<[number, Array<[string, number | undefined]>]>;
const LootGrid = ({ data, tight }: { data: Data; tight?: boolean }) => {
  const screenSize = useScreen();

  data.sort(([odds1], [odds2]) => odds2 - odds1);

  return (
    <div className={"grid " + (tight ? "" : "md:grid-cols-2")}>
      {data.map(([odds, drops], idx) => {
        let bgClass = "";
        if (idx % 4 == 0) {
          bgClass = " bg-bg2";
        } else if (idx % 4 == 2 && screenSize >= 4) {
          bgClass = " bg-bg2";
        } else if (idx % 4 == 3 && screenSize < 4) {
          bgClass = " bg-bg2";
        }

        const odds2 = odds == 999.2 ? 0.2 : odds;

        return (
          <div className={`flex items-center px-4 py-4 pb-3 gap-2 ${bgClass}`}>
            <div className="w-10 pr-1 font-montserrat font-medium text-right">
              {formatOdds(odds2)}%
            </div>
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-y-[10px]">
              {(drops || []).map(([typ, count, ...rest]) => {
                const fixTyp = Array.isArray(typ) ? typ[0] : typ;
                return <LootItem typ={fixTyp} count={count || 1} rest={rest} />;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LootGrid;
